import { TemplateRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { BranchesService } from 'src/app/services/branches/branches.service';
import { CryptService } from 'src/app/services/crypt.service';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.css']
})
export class BranchesComponent implements OnInit {
  canvasRotation
  imageChangedEvent
  showImage: boolean = true
  modalRef
  disableSelect
  companyType
  selectedcompanyType
  selectedLevel
  selectedMain
  Main
  selected
  Status
  Level
  showUpdate
  NewsDetails
  imgUrl
  selectedLang: string
  languages: any
  loadPage = true
  rowsPage: number
  tableNews
  selectedRows
  showTableNews: boolean = false
  BrnDetails: string = ''
  public Editor = ClassicEditor;
  showSave: boolean = false
  showcancel: boolean = false
  showNew: boolean = true
  showDataPanle
  BrnId
  BrnName
  BrnTitle
  BrnAddress
  BrnPho1
  BrnPho2
  BrnEmail
  BrnFax
  disableSelectLang
  disableSelectType
  disableSelectLevel


  fbrn_sys = 'Faculty'

  save() {
    this.loadPage = false
    this.showSave = false
    if (this.Validation()) {
      this.brn.branchesPost(

        'i', this._Activatedroute.snapshot.paramMap.get("id").toString(), null, null, this.selectedLang, this.BrnId,

        this.BrnName, this.BrnTitle, this.BrnAddress,

        this.BrnPho1, this.BrnPho2, this.BrnEmail, this.BrnFax, this.croppedImage,

        this.selected, this.c.Decrypt(sessionStorage.getItem("usrId")), this.c.Decrypt(sessionStorage.getItem('brnId')), this.BrnDetails

      )
        .subscribe(data => {
          this.getDataNews()
          this.clearData()
          this.btnclose()
          this._snackBar.open(data[0]["column1"], 'حسنا', {
            duration: 5000,
            horizontalPosition: 'left'
          });
          this.loadPage = true
        })
    }
    else {
      this.showSave = true
      this.loadPage = true
    }
  }


  btnNew() {
    this.disableSelect = null
    this.showSave = true
    this.showcancel = true
    this.showNew = false
    this.showDataPanle = true
    this.showUpdate = false
    this.clearData();
    this.showTableNews = true

    this.brn.getLangIsMain().subscribe(data => {
      this.selectedLang = data[0]['LangId']
    });
     this.disableSelectLang = new UntypedFormControl(false)
    this.disableSelectType = false
    this.disableSelectLevel = false
  }
  btnclose() {
    this.showSave = false
    this.showcancel = false
    this.showNew = true
    this.showDataPanle = false
    this.showUpdate = false
    this.clearData();
    this.showTableNews = false
  }
  btnUpdate() {
    this.showDataPanle = true
    this.showSave = false
    this.showcancel = true
    this.showUpdate = true;

    this.showNew = false
    this.showTableNews = true
  }

  getDataNews(): void {
    this.getRows('1')
    this.loadPage = true
  }
  clearData(): void {
    this.BrnId = ''
    this.id_delete = ''
    this.id_lang = ''
    this.selectedMain = ''
    this.selectedcompanyType = ''
    this.selectedLevel = ''
    this.selectedLang = ''
    this.BrnEmail = ''
    this.BrnFax = ''
    this.BrnPho1 = ''
    this.BrnPho2 = ''
    this.BrnName = ''
    this.BrnTitle = ''
    this.BrnAddress = ''
    this.BrnDetails = ''
    this.imageChangedEvent = '';
    this.croppedImage = 'data:image/jpeg;base64,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';
    this.imgUrl = ''
    this.brn.getBrnlang(null).subscribe(data => {
      this.languages = data
    })
  }
 
  showData(id, langId): void {
    
    this.loadPage = false
    this.disableSelect = null
    this.brn.getBrnWhereId(id, langId).subscribe(data => {
      this.BrnId = data[0]['BrnId'].toString()
      this.BrnName = data[0]['BrnName'].toString()
      this.BrnTitle = data[0]['BrnTitle'].toString()
      this.BrnAddress = data[0]['BrnAddress'].toString()
      this.BrnDetails = data[0]['BrnAbout'].toString()
      this.BrnPho1 = data[0]['BrnPho1'].toString()
      this.BrnPho2 = data[0]['Brnpho2'].toString()
      this.BrnEmail = data[0]['BrnEmail'].toString()
      this.BrnFax = data[0]['BrnFax'].toString()
      this.selectedLang = data[0]['FlangId'].toString()
      this.selected = data[0]['Fstate']
      this.croppedImage = data[0]["base64"]

      setTimeout(() => {
        this.brn.getCompanyType().subscribe(data => {
          this.companyType = data
        });
      }, 100);
      this.selectedcompanyType = data[0]['brnSys'].toString()
      setTimeout(() => {
        this.brn.getLevel(data[0]['brnSys'].toString()).subscribe(data => {
          this.Level = data
        });
      }, 100);
      this.selectedLevel = data[0]['FlevelId']
      setTimeout(() => {
        this.brn.getMain(data[0]['FlevelId'].toString(), data[0]['brnSys'].toString(), '1', data[0]['FlangId'].toString()).subscribe(data => {
          this.Main = data
          if (data.length == 0) {
            this.disableSelect = new UntypedFormControl(false)
            this.selectedMain = '0'
          }
          else {
            this.disableSelect = false
          }
        });
      }, 100);
      this.loadPage = true
    });
    this.btnUpdate()
    this.disableSelectLang = new UntypedFormControl(false)
    this.disableSelectType = new UntypedFormControl(false)
    this.disableSelectLevel = new UntypedFormControl(false)
  }


    update() {
    this.loadPage = false
    this.showSave = false
    if (this.Validation()) {
      this.brn.branchesPost(

        'u', this._Activatedroute.snapshot.paramMap.get("id").toString(), null, null, this.selectedLang, this.BrnId,

        this.BrnName, this.BrnTitle, this.BrnAddress,

        this.BrnPho1, this.BrnPho2, this.BrnEmail, this.BrnFax, this.croppedImage,

        this.selected, this.c.Decrypt(sessionStorage.getItem("usrId")), this.c.Decrypt(sessionStorage.getItem('brnId')), this.BrnDetails

      )
        .subscribe(data => {
          this.getDataNews()
          this.clearData()
          this.btnclose()

          this._snackBar.open(data[0]["column1"], 'حسنا', {
            duration: 5000,
            horizontalPosition: 'left'
          });
          this.loadPage = true
        })
    }
    else {
      this.showSave = true
      this.loadPage = true
    }
  }


  showNewslang(id, langId): void {
    this.disableSelectLang = null
    this.clearData()
    this.brn.getBrnWhereId(id, langId).subscribe(data => {
      this.BrnId = data[0]["BrnId"].toString()
      this.BrnName = data[0]['BrnName'].toString()
      this.BrnTitle = data[0]['BrnTitle'].toString()
      this.BrnAddress = data[0]['BrnAddress'].toString()
      this.BrnDetails = data[0]['BrnAbout'].toString()
      this.BrnPho1 = data[0]['BrnPho1'].toString()
      this.BrnPho2 = data[0]['Brnpho2'].toString()
      this.BrnEmail = data[0]['BrnEmail'].toString()
      this.BrnFax = data[0]['BrnFax'].toString()
      this.selectedLang = ''
      setTimeout(() => {
        this.brn.getCompanyType().subscribe(data => {
          this.companyType = data
        });
      }, 100);
      this.selectedcompanyType = data[0]['brnSys'].toString()

      setTimeout(() => {
        this.brn.getMain(data[0]['FlevelId'].toString(), data[0]['brnSys'].toString(), '1', data[0]['FlangId'].toString()).subscribe(data => {
          this.Main = data
          if (data.length == 0) {
            this.disableSelect = new UntypedFormControl(false)
            this.selectedMain = '0'
          }
          else {
            this.disableSelect = false
          }
        });
      }, 100);
      this.imgUrl = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wAARCAEsASwDASIAAhEBAxEB/8QAGgABAQEBAQEBAAAAAAAAAAAAAAUDBAIBB//EADIQAQABAgEJCAICAwEBAAAAAAABAgMEBRIUFTM0UVNyERMxcYGRorEhIkGhMlJhQ9H/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARsZM6Vc/M+LDOnjLbGb3c82IGdPGTOnjIAZ08ZM6eMgBnTxkzp4yAGdPGTOnjIAZ08ZM6eMgBnTxkzp4yAGdPGTOnjIAZ08ZM6eMgBnTxkzp4yAGdPGTOnjIAZ08ZM6eMgBnTxkzp4yAGdPGTOnjIAZ08ZUslzM2q+3/ZNUsl7KvqB3AAAAAAAAi4ze7nmxbYze7nmxB7s2pvXYtxMRM/zLq1bc5lLLAb5R6/SwCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCZq25zKTVtzmUqYCXXk+uiiqqa6f1jtca5f2Fzpn6QwFLJeyr6k1SyXsq+oHcAAAAAAACLjN7uebFtjN7uebEHRgN8o9fpYR8BvlHr9LAAAAAAAAAAAAAAAAAAAAAAAM7+wudM/SGuX9hc6Z+kMBSyXsq+pNUsl7KvqB3AAAAAAAAi4ze7nmxbYze7nmxB0YDfKPX6WEfAb5R6/SwAAA57+MtWJzZ7aquEPuMvdzYmqP8p/EI0z2z2z4goaz/ADsvx1Omxird/wDFM9lX+s+KM+01TTVFVM9kx4SC+MsPd76zTX/M+Pm1AAAAAAABneu02bc11eEf2DQeaKoropqjwmO16AAAABnf2Fzpn6Q1y/sLnTP0hgKWS9lX1JqlkvZV9QO4AAAAAAAEXGb3c82LbGb3c82IOjAb5R6/Swj4DfKPX6WAAAcOVInuqJ/jOTVy/ai9aqon+fCeEot23VarmmuOyYB5BpYs1364pojzngCjk2JjC/n+ap7HW8W6It26aKfCI7HsAAAAAAHxJx2I765m0z+lP9y68oYju7fd0z+1X9Qlgp5Mu51qbc+NPh5O1Fwl3usRTVPhP4nyWgAAAAZ39hc6Z+kNcv7C50z9IYClkvZV9SapZL2VfUDuAAAAAAABFxm93PNi2xm93PNiDowG+Uev0sI+A3yj1+lgAAB4rt0XI7K6Yqj/AK9gObQcP29vd/3LeiiminNopimOEPQAAD5VVFNM1TPZEfmWdi9RfozqJ84nxhyZSxH/AI0z/wBq/wDjis3q7NyK6J844gujKxfov286n1jg1AZ3rlNm3NdXhH9vaVjsR31zNpn9Kf7kHPcuVXbk11eMvIALODu97h6Znxj8SjOzJt3NvTbnwrj8eYKgAAAM7+wudM/SGuX9hc6Z+kMBSyXsq+pNUsl7KvqB3AAAAAAAAi4ze7nmxbYze7nmxB0YDfKPX6WEfAb5R6/SwAAADDF3u5sTVH+U/iPMG44cFjM/st3Z/b+J4u4BliL0WLU1z4/xHGWiRjb/AH13spn9KfxH/f8AoMKqpqqmqqe2Z/MvgA92b1dm5FdE+ccVixeov286n1jgiPdm9XYuRXRPnHEFHH4jurfd0z+9X9QlvV25VduTXV4y8gAAPtFU0VxVHjE9sPgC9bri5bprjwmO16cOTLudbqtz40/mPJ3AAAzv7C50z9Ia5f2Fzpn6QwFLJeyr6k1SyXsq+oHcAAAAAAACLjN7uebFtjN7uebEHRgN8o9fpYR8BvlHr9LAAACRlC93t/Nif1o/HqoYu93Niao/yn8R5owClgsZn9lu7P7fxPFNAVMoYju7eZTP7V/1CW+111V1Z1czM8ZfAAAAAAAAAAAa4W73OIpq/jwnyWkBYwV3vcPTM+NP4kHQADO/sLnTP0hrl/YXOmfpDAUsl7KvqTVLJeyr6gdwAAAAAAAIuM3u55sW2M3u55sQdGA3yj1+lhHwG+Uev0sAAzv1V02apt0zVV4R2AmZQvd7fzYn9aPx6uZrot/lVexot/lVewMhrot/lVexot/lVewMhrot/lVexot/lVewMhrot/lVexot/lVewMhrot/lVexot/lVewMhrot/lVexot/lVewMhrot/lVexot/lVewMhrot/lVexot/lVewMnXk27mXponwrj+2Oi3+VV7PtOHxFNUVRbq7Yntj8AtDzTOdTEzHZMx4T/D0DO/sLnTP0hrl/YXOmfpDAUsl7KvqTVLJeyr6gdwAAAAAAAIuM3u55sW2M3u55sQdGA3yj1+lhHwG+Uev0sAAAAAAAAAAAAAAAAAAAAAAAzv7C50z9Ia5f2Fzpn6QwFLJeyr6k1SyXsq+oHcAAAAAAACLjN7uebFtjN7uebEHq1cqs3Irp7O2OLp1je4UezkAdesb3Cj2NY3uFHs5AHXrG9wo9jWN7hR7OQB16xvcKPY1je4UezkAdesb3Cj2NY3uFHs5AHXrG9wo9jWN7hR7OQB16xvcKPY1je4UezkAdesb3Cj2NY3uFHs5AHXrG9wo9jWN7hR7OQB16xvcKPY1je4UezkAdesb3Cj2NY3uFHs5AHXrG9wo9jWN7hR7OQB01Y+9XRNMxR2THZ4OYAFLJeyr6k1SyXsq+oHcAAAAAAACLjN7uebFtjN7uebEAAAAAAAAAAAAAAAAAAAAAAAAAABSyXsq+pNUsl7KvqB3AAAAAAAAi4ze7nmxbYze7nmxAAAAAAAAAAAAAAAAAAAAAAAAAAAUsl7KvqTVLJeyr6gdwAAAAAAAIuM3u55sW2M3u55sQAAAAAAAAAAAAAAAAAAAAAAAAAAFLJeyr6k1SyXsq+oHcAAAAAAACLjN7uebFZrwli5XNVVHbVPjPbL5oOH5fykEcWNBw/L+Umg4fl/KQRxY0HD8v5SaDh+X8pBHFjQcPy/lJoOH5fykEcWNBw/L+Umg4fl/KQRxY0HD8v5SaDh+X8pBHFjQcPy/lJoOH5fykEcWNBw/L+Umg4fl/KQRxY0HD8v5SaDh+X8pBHFjQcPy/lJoOH5fykEcWNBw/L+Umg4fl/KQRxY0HD8v5SaDh+X8pBHFjQcPy/lJoOH5fykEcWNBw/L+Umg4fl/KQR1LJeyr6m2g4fl/KWlqzbsxMW6eyJ/6DQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/2Q==';
      this.brn.getBrnlang(id).subscribe(data => {
        this.languages = null
        this.languages = data

      });


    });
    this.btnNew()
    this.disableSelectType = new UntypedFormControl(false)
    this.disableSelectLevel = new UntypedFormControl(false)
    this.disableSelectLang = false
  }



  toggle(): void {

    this.showSave = !this.showcancel
  }

  constructor(private c: CryptService, private _Activatedroute: ActivatedRoute, private brn: BranchesService, private _snackBar: MatSnackBar, private modalService: BsModalService) { }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }



  id_delete: string
  id_lang: string
  message
  delete(template: TemplateRef<any>, id, langId): void {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
    this.id_delete = id
    this.id_lang = langId
  }


  confirm(): void {
    this.loadPage = false
    this.brn.deleteBrn('d', this.id_delete, this.id_lang).subscribe(data => {
      this.getDataNews()
      this.clearData()

      this._snackBar.open(data[0]["column1"], 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      this.loadPage = true
    });
    this.id_delete = ''
    this.id_lang = ''
    this.modalRef.hide();
  }
  croppedImage: any = '';
  decline(): void {
    this.message = 'Declined!';
    this.modalRef.hide();
  }



  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.showImage = false
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

  }


  cut() {
    this.showImage = true
  }

  imageLoaded() {
  }
  cropperReady() {
  }

  loadImageFailed() {
    //console.error('Failed to load image: ');
  }



  Validation(): boolean {

    if (this.selectedLang == '' || this.selectedLang == null) {
      this._snackBar.open('الرجاء اختيار اللغة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      return false;
    }
    else if (this.croppedImage == '' || this.croppedImage == null) {

      this._snackBar.open('الرجاء اختيار صورة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      return false;
    }
    else if (this.BrnName == '' || this.BrnName == null) {

      this._snackBar.open('الرجاء ادخال الاسم اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      return false;
    }
    else if (this.selected == null) {

      this._snackBar.open('الرجاء اختيار الحالة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      return false;
    }

    return true;
  }


  onChangeComType() {
    setTimeout(() => {
      if (this.selectedcompanyType == null || this.selectedcompanyType == '') {
        console.log('Lang Null ...')
      }
      else {
        this.brn.getLevel(this.selectedcompanyType).subscribe(data => {
          this.Level = data
        });
      }
    }, 100);

  }

  onChangeLevel() {
    setTimeout(() => {
      if (this.selectedLevel == null || this.selectedLevel == '') {
        console.log('Lang Null ...')
      }
      else {
        this.brn.getMain(this.selectedLevel, this.fbrn_sys, '1', this.selectedLang).subscribe(data => {
          this.Main = data
          if (data.length == 0) {
            this.disableSelect = new UntypedFormControl(false)
            this.selectedMain = '0'
          }
          else {
            this.disableSelect = false
          }
        });
      }
    }, 100);
  }
  pageNumbers

  getRows(num) {
    if (this.rowsPage == null)
      this.rowsPage = 10
    this.brn.viewBrnPaging(num, this.rowsPage, this._Activatedroute.snapshot.paramMap.get("id"),this.c.Decrypt(sessionStorage.getItem('syslang'))).subscribe(data => {
      this.tableNews = data['data1']
      this.pageNumbers = data['data2']
    })
  }
  getPage(event: any) {
    this.rowsPage = event.target.value;
    this.brn.viewBrnPaging(1, this.rowsPage, this._Activatedroute.snapshot.paramMap.get("id"),this.c.Decrypt(sessionStorage.getItem('syslang'))).subscribe(data => {
      this.tableNews = data['data1']
      this.pageNumbers = data['data2']
     
    })
  }

  public ff(){
     this.brn.getPageName(this._Activatedroute.snapshot.paramMap.get("id"),this.c.Decrypt(sessionStorage.getItem('syslang'))).subscribe(data=>{
     // this.namebrn = data[0]['PageTitle']
      data.forEach(x=>{
        if(x.FlangId == this.c.Decrypt(sessionStorage.getItem('syslang')))
        {
          this.namebrn = x.PageTitle
        }
      })
    })
  }
  namebrn: string = ''
  ngOnInit(): void {
    this.ff()
  
    this.loadPage = false

    this.brn.getBrnStatus().subscribe(data => {

      this.Status = data;
    });

    this.brn.getBrnlang(null).subscribe(data => {
      this.languages = data
      // console.log(data)
    });
    this.brn.getCompanyType().subscribe(data => {
      this.companyType = data
    });

    this.getDataNews()
    this.loadPage = true


    this.brn.getMain('a', this.fbrn_sys, '1', 'ar').subscribe(data => {
      this.Main = data
      // console.log(data)
      if (data.length == 0) {
        this.disableSelect = new UntypedFormControl(false)
        this.selectedMain = '0'
      }
      else {
        this.disableSelect = false
      }
    });

  }
}
